import { useEffect } from "react";

/** Injects <meta name="robots" content="noindex,nofollow"> while mounted.
 *  Frontend-layer noindex protection for private/auth/confirmation routes. */
export default function useNoIndex() {
  useEffect(() => {
    let tag = document.head.querySelector('meta[name="robots"][data-cd-noindex]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "robots");
      tag.setAttribute("data-cd-noindex", "1");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", "noindex,nofollow");
    return () => { tag && tag.remove(); };
  }, []);
}
